import React, { FC, PropsWithChildren } from 'react';

import { fallback } from '@wagmi/core';
import { Transport } from 'viem';
import { WagmiProvider, createConfig, http } from 'wagmi';
import {
  Chain,
  arbitrum,
  avalanche,
  base,
  bsc,
  fantom,
  manta,
  optimism,
  pulsechain,
} from 'wagmi/chains';
import {
  coinbaseWallet,
  injected,
  metaMask,
  walletConnect,
} from 'wagmi/connectors';

import { CHAINS_RPC, CHAIN_ID } from '@constants/common/chain.constants';

export const sonic = {
  id: 146,
  name: 'Ethereum',
  nativeCurrency: { name: 'Sonic', symbol: 'S', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.soniclabs.com'] },
  },
  blockExplorers: {
    default: { name: 'Soniclabs', url: 'https://explorer.soniclabs.com/' },
  },
  contracts: {
    multicall3: {
      address: '0x96116c5C5C760bffC0D06017F96dBBBF25621AdA',
      blockCreated: 14353601,
    },
  },
} as const satisfies Chain;

const chains: [Chain, ...Chain[]] = [
  // bsc,
  // fantom,
  // optimism,
  // arbitrum,
  // avalanche,
  base,
  // pulsechain,
  // manta,
  // sonic,
];

const transports = chains.reduce(
  (acc, chain) => {
    const httpStrings: string[] | readonly string[] = CHAINS_RPC[
      chain.id as CHAIN_ID
    ]
      ? CHAINS_RPC[chain.id as CHAIN_ID]
      : [];

    return {
      ...acc,
      [chain.id]: fallback(httpStrings.map((item) => http(item))),
    };
  },
  {} as Record<number, Transport>,
);

export const CLIENT_CONFIG = {
  batch: {
    multicall: {
      batchSize: 1024 * 200,
      wait: 16,
    },
  },
  pollingInterval: 6_000,
};

export const metaMaskConnector = metaMask();
export const injectedConnector = injected({
  shimDisconnect: false,
});
export const coinbaseConnector = coinbaseWallet({
  appName: 'dexfi',
  appLogoUrl: '',
});

export const trustConnector = injected({
  target: 'trust',
  shimDisconnect: false,
});
export const walletConnectConnector = walletConnect({
  showQrModal: true,
  projectId: 'b0cff6026f93d0adda95a835f59a957d',
  qrModalOptions: {
    themeVariables: {
      '--wcm-z-index': '9999999',
    },
  },
});

export const config = createConfig({
  chains,
  syncConnectedChain: true,
  transports,
  ssr: true,
  ...CLIENT_CONFIG,
  connectors: [
    metaMaskConnector,
    injectedConnector,
    walletConnectConnector,
    coinbaseConnector,
    trustConnector,
  ],
});

const chainIdTuple = [...new Set(chains.map((chain) => chain.id))] as const;

export type ConfigChainIds = (typeof chainIdTuple)[number];

export const Wagmi: FC<PropsWithChildren> = ({ children }) => (
  <WagmiProvider config={config}>{children}</WagmiProvider>
);
